module.exports = function(gantt) {
	gantt.getGridColumn = function (name) {
		var columns = gantt.config.columns;

		for (var i = 0; i < columns.length; i++) {
			if (columns[i].name == name)
				return columns[i];
		}

		return null;
	};
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/grid_column_api.gpl.js
// module id = 68
// module chunks = 0